import React, { useState,useEffect } from "react";
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import {
    Logo,
    Profile,
    Service,
    HomeLogo
} from 'src/assets/index';
import { Popup } from 'src/reusable/index';

var appUrl = `${process.env.REACT_APP_API_HOST}`;

function MemHeader(props) {
    const { onClickMenu, isSelAfcr, isSelSection, isLife, isChange, onChgangeAfcr, isAssApiSelAfcr } = props;
    const state = useSelector((state) => state.memInfo);
    const history = useHistory();
    const { memNo } = state;
    const [showPopup, setShowPopup] = useState({
		isOpen: false,
		text: '',
		btnNm: '',
	});

    function goHome() {
        history.push('/ezp-2/mem');
    }

    async function handleChangeAfcr(type) {
        await onChgangeAfcr(type);
    }

    async function handleClosePopup() {
		document.getElementsByTagName("body")[0].style.overflow = "scroll";
		await setShowPopup({
			...showPopup,
			isOpen: false,
		});

		await history.push('/ezp-2/login');
	}

    useEffect(() => {
        if(!memNo) {
            setShowPopup({
                ...showPopup,
                isOpen: true,
                text: '로그인 정보가 없습니다.\n로그인화면으로 이동합니다.',
                btnNm: '확인',
            });
        }
    }, []);

    return (
        <>
        <header className="header-wrapper">
            <header className="header-container">
                <button type="button" className="backBtn">
                {/* {state.prflFileNm !== null ? 
                    <img src={`${appUrl}ezp2/mem/:${(state.memNo != "" ? state.memNo : "0")}/memInfo/getImages/prflFileNm?${state.prflFileNm}`} alt="프로필" className="header-sideBtn jjy3" />
                :""}
                {state.prflFileNm == null ? 
                    <img src={Profile} alt="프로필" className="header-sideBtn jjy3" />
                :""} */}
                 <img src={HomeLogo} className="header-sideBtn jjy3"  alt="home" onClick={goHome}/>
                    </button>
                <img src={Logo} alt="logo" className="header-logo" onClick={goHome} />
                <button type="button" className="backBtn" onClick={onClickMenu}>
                    <img src={Service} alt="설정" className="header-sideBtn" />
                </button>
            </header>
            {isSelAfcr &&
                <nav className="navBox">
                    <button type="button" className={`navBtn ${isLife ? 'navBtn-active' : ''}`} disabled={isChange && !isLife} onClick={() => handleChangeAfcr('L')}>생명보험사</button>
                    <button type="button" className={`navBtn ${!isLife ? 'navBtn-active' : ''}`} disabled={isChange && isLife} onClick={() => handleChangeAfcr('F')}>손해보험사</button>
                </nav>
            }
            {isSelSection &&
                <nav className="navBox">
                    <button type="button" className='navBtn navBtn-active' disabled>상품군 선택</button>
                </nav>
            }
            {isAssApiSelAfcr &&
                <nav className="navBox">
                    <button type="button" className='navBtn navBtn-active' disabled>보험사 선택</button>
                </nav>
            }
        </header>
        {showPopup.isOpen && <Popup text={showPopup.text} btnNm={showPopup.btnNm} onClose={handleClosePopup} />}
        </>
    )
}

export default React.memo(MemHeader)